import { setDisableScrolling } from '@/common/utils/common'
import { goLoginPageWithReferer, isAdultVerification, openAdultPopupIfNeeded } from '@/common/utils/adult'
import _ from 'lodash'
import constant from '@/common/resources/constant'
import { changeProfileProc } from '@/common/utils/login'
import { PLAYER_EVENT } from '@/common/utils/player.interface'
import {
  PATH_NAME_PLAYER_LIVE,
  PATH_NAME_PLAYER_MOVIE,
  PATH_NAME_PLAYER_STREAM,
  PATH_NAME_PLAYER_VOD
} from '@/common/resources/router.const'
import { ATTR_BY_PLAYER_TYPE } from '@/common/resources/player.const'
import { getPreviousRouterIfRetreatPath } from '@/common/utils/router.utils'
import router from '@/router'
import cookie from '@/common/utils/cookie'
import { getReferer } from '@/common/utils/referer'

/**
 * 플레이어와 관련된 공통 페이지 mixin
 * delegate를 통한 플레이어와의 통신 후처리
 * 그외 공통 기능
 * WARNING :: 플레이어 전용 페이지 stream
 * TODO :: 비사용로직 정리 필요
 */
export default {
  data () {
    return {
      isPlay: false,
      isPlayAd: false,
      ogTitle: '',
      ogUrl: window.location.protocol + '//' + window.location.host + window.location.pathname + window.location.search,
      ogDescription: '',
      ogImage: ''
    }
  },
  methods: {
    async checkAdultContent () {
      if (cookie.isNotVerifiedAdultUser()) {
        const { isAdultVerified } = await isAdultVerification()
        await openAdultPopupIfNeeded({ isAdultVerified })
      }
    },
    /**
     * 전역선언하는 함수들 (플레이어 안에서 호출)
     */
    delegateGlobalFunctions () {
      let self = this
      // 회원 가입 페이지 이동
      window.gotoSignup = function () {
        window.location.href = constant.URL_MEMBER_SIGNUP
      }
      // 실명 인증 페이지 이동
      window.gotoAuthorization = function () {
        window.location.href = constant.URL_MEMBER_ME
      }
      // 광고 재생 여부 변경
      window.isPlayAd = function (isPlayAd) {
        self.isPlayAd = isPlayAd
      }
      // 프로필 정보가 바꼈을 때 리로그인 처리
      window.reLoginProc = function () {
        changeProfileProc({ profileId: 0 }).then(() => {
          window.location.reload()
        })
      }
      // 공유 레이어 팝업
      window.showShareLayout = function () {
        self.shareLayout = true
        setDisableScrolling(true) // 윈도우 스크롤 방지
      }
    },
    delegatePlayEvent () {
      this.$events.$on(PLAYER_EVENT.PLAY, function (info) {
        this.isPlay = true
      }.bind(this))
    },
    delegateShowToast () {
      this.$events.$on(PLAYER_EVENT.SHOW_TOAST, async (info) => {
      })
    },
    /**
     * 플레이어 내 back키로 페이지 이동
     * 진입 경로가 상세가 아닌 경우 진입했던 라우터로 이동
     * 플레이어가 주는 값으로 라우터 이동처리
     */
    delegateMovePage () {
      this.$events.$on(PLAYER_EVENT.MOVE_PAGE, async (info) => {
        if (!info || info.length < 2) {
          return
        }
        // movePage는 현재 movie ,vod만 들어옴. onairvod도 들어오는데 vod로 처리하기위해 아래와 같이 처리
        // TODO:: live, baseball 차후 대응 필요
        const contentId = info[0]
        const contentType = info[1] === 'movie' ? 'movie' : 'vod'
        const addInfo = info[2]
        const streamRoute = {
          name: contentType === 'movie' ? PATH_NAME_PLAYER_MOVIE : PATH_NAME_PLAYER_VOD,
          params: {
            section: contentType
          },
          query: {}
        }
        streamRoute.query[ATTR_BY_PLAYER_TYPE[contentType].id] = contentId
        /**
         * 정책 반영 (세번째 인자 addinfo {} 추가)
         * vod일 경우 addinfo 내 programid가 있으면 우선 적용 (암만 생각해도 history=season같은데 회의에서 all로 결정되어 반영)
         * movie일 경우 addinfo 내 originalmovieid가 있으면 movieid 대체 (예고편 시청 -> 본편 상세 이동)
         */
        if (addInfo) {
          if (addInfo.hasOwnProperty('needlogin') && addInfo.needlogin === true) {
            goLoginPageWithReferer(encodeURIComponent(getReferer()))
            return
          }
          if (addInfo.hasOwnProperty('needadultverify') && addInfo.needadultverify === true) {
            await this.checkAdultContent()
            return
          }
          if (contentType === 'vod' && addInfo.hasOwnProperty('programid') && addInfo.programid !== '') {
            streamRoute.query = {
              programid: addInfo.programid,
              history: 'all'
            }
          } else if (contentType === 'movie' && addInfo.hasOwnProperty('originalmovieid') && addInfo.originalmovieid !== '') {
            streamRoute.query[ATTR_BY_PLAYER_TYPE[contentType].id] = addInfo.originalmovieid
          }
        }

        try {
          const path = getPreviousRouterIfRetreatPath()
          if (path !== '') {
            await router.push(path)
            return
          }
          await this.$router.push(streamRoute)
        } catch (e) {
          console.log(e)
        }
      })
    },
    delegateUpdateEvent () {
      // TODO:: 동작 확인 필요
      this.$events.$on(PLAYER_EVENT.UPDATE, async (info) => {
        const contentId = _.get(info, 'contentID', null)
        const contentType = _.get(info, 'type', null)
        if (!contentId || !contentType) {
          return false
        }
        const streamRoute = {
          name: contentType !== 'live' ? PATH_NAME_PLAYER_STREAM : PATH_NAME_PLAYER_LIVE,
          params: {
            section: contentType
          },
          query: {}
        }
        streamRoute.query[ATTR_BY_PLAYER_TYPE[contentType].id] = contentId
        try {
          const query = this.$route.query
          if (query[ATTR_BY_PLAYER_TYPE[contentType].id] === contentId) {
            await this.$router.go(0)
          } else {
            await this.$router.replace(streamRoute)
          }
        } catch (e) {
          console.log(e)
        }
      })
    }
  },
  created () {
    this.delegateGlobalFunctions()
    this.delegateUpdateEvent()
    this.delegateMovePage()
  },
  beforeDestroy () {
    this.$events.$off(PLAYER_EVENT.UPDATE)
    this.$events.$off(PLAYER_EVENT.PLAY)
    this.$events.$off(PLAYER_EVENT.MOVE_PAGE)
  }
}
